import { useTranslation } from "react-i18next";

const F = "'Segoe UI', Arial, Helvetica, sans-serif";

export function PdfSheet({ id, accent = "#0d9488", dark = "#042f2e", emoji = "🍽", title, maison, meta = [], stats = [], children }) {
  const { t } = useTranslation();
  const now = new Date();
  return (
    <div id={id} className="hidden" style={{ background: "#ffffff", color: "#0f172a", fontFamily: F, width: "100%" }}>
      <div style={{ background: `linear-gradient(120deg, ${dark} 0%, ${accent} 100%)`, padding: "24px 32px", color: "#fff", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div>
          <div style={{ fontSize: 10, letterSpacing: 3, textTransform: "uppercase", opacity: 0.75, fontWeight: 700 }}>CarePilot · {maison}</div>
          <div style={{ fontSize: 25, fontWeight: 900, marginTop: 4 }}>{emoji} {title}</div>
          <div style={{ fontSize: 12, opacity: 0.9, marginTop: 3, textTransform: "capitalize" }}>{meta.filter(Boolean).join("  ·  ")}</div>
        </div>
        <div style={{ fontSize: 34, opacity: 0.5 }}>{emoji}</div>
      </div>
      {stats.length > 0 && (
        <div style={{ display: "flex", gap: 8, padding: "14px 32px 0" }}>
          {stats.map(([v, l, c], i) => (
            <div key={i} style={{ flex: 1, background: "#f8fafc", border: "1px solid #e2e8f0", borderTop: `3px solid ${c || accent}`, borderRadius: 10, padding: "8px 6px", textAlign: "center" }}>
              <div style={{ fontSize: 19, fontWeight: 900, color: c || accent }}>{v}</div>
              <div style={{ fontSize: 8, fontWeight: 800, textTransform: "uppercase", color: "#64748b", letterSpacing: 0.5 }}>{l}</div>
            </div>
          ))}
        </div>
      )}
      <div style={{ padding: "16px 32px 8px" }}>{children}</div>
      <div style={{ margin: "0 32px", borderTop: "2px solid #e2e8f0", padding: "10px 0 22px", display: "flex", justifyContent: "space-between", alignItems: "flex-end", fontSize: 9, color: "#64748b" }}>
        <div>
          <div style={{ fontWeight: 800, color: accent, fontSize: 10 }}>CarePilot — {maison}</div>
          <div>{t("pdf.generatedOn")} {now.toLocaleDateString("fr-BE")} · {now.toLocaleTimeString("fr-BE", { hour: "2-digit", minute: "2-digit" })}</div>
          <div style={{ maxWidth: 430, marginTop: 2 }}>{t("pdf.rgpdNote")}</div>
        </div>
        <div style={{ textAlign: "center" }}>
          <div style={{ borderBottom: "1px solid #94a3b8", width: 160, height: 26 }} />
          <div style={{ marginTop: 3, fontWeight: 700 }}>{t("pdf.signature")}</div>
        </div>
      </div>
    </div>
  );
}

export function PdfSection({ title, accent = "#0d9488", children }) {
  return (
    <div style={{ marginBottom: 12 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
        <span style={{ width: 4, height: 15, background: accent, borderRadius: 2, display: "inline-block" }} />
        <span style={{ fontSize: 12.5, fontWeight: 900, textTransform: "uppercase", letterSpacing: 1 }}>{title}</span>
      </div>
      {children}
    </div>
  );
}

export function PdfTable({ headers, rows, accent = "#0d9488", widths = [] }) {
  return (
    <div style={{ borderRadius: 10, overflow: "hidden", border: "1px solid #e2e8f0" }}>
      <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 10 }}>
        <thead><tr>{headers.map((h, i) => <th key={i} style={{ background: accent, color: "#fff", padding: "7px 8px", textAlign: "left", fontSize: 8.5, textTransform: "uppercase", letterSpacing: 0.5, width: widths[i] }}>{h}</th>)}</tr></thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={i} style={{ background: i % 2 ? "#f8fafc" : "#fff" }}>
              {r.map((c, j) => <td key={j} style={{ padding: "6px 8px", borderTop: "1px solid #e2e8f0", verticalAlign: "top" }}>{c}</td>)}
            </tr>
          ))}
          {rows.length === 0 && <tr><td colSpan={headers.length} style={{ padding: 10, color: "#94a3b8", textAlign: "center" }}>—</td></tr>}
        </tbody>
      </table>
    </div>
  );
}

export function PdfBadge({ color = "#0d9488", children }) {
  return <span style={{ background: color, color: "#fff", fontWeight: 800, fontSize: 8, padding: "2px 7px", borderRadius: 99, textTransform: "uppercase", display: "inline-block", marginRight: 3, marginBottom: 2 }}>{children}</span>;
}
